// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2Eaw7","loaderOuter":"PageOverlayLoader_loaderOuter__2SHA1"};